export const getNativeWindow = (): Window => {
    return window;
};
